import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Heritage from "@/components/Heritage";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import QuoteForm from "@/components/QuoteForm";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  const [selectedService, setSelectedService] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const scrollTo = useCallback((id) => {
    const el = document.querySelector(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
    else el.scrollIntoView({ behavior: "smooth" });
  }, []);

  const requestQuote = useCallback(
    (service) => {
      if (service) setSelectedService(service);
      scrollTo("#quote");
    },
    [scrollTo]
  );

  return (
    <div className="bg-white text-zinc-900">
      <Toaster position="top-center" richColors />
      <Navbar scrollTo={scrollTo} onQuote={() => requestQuote("")} />
      <main>
        <Hero scrollTo={scrollTo} onQuote={() => requestQuote("")} />
        <Marquee />
        <Heritage />
        <Services onQuote={requestQuote} />
        <Gallery />
        <Reviews />
        <QuoteForm
          selectedService={selectedService}
          setSelectedService={setSelectedService}
        />
        <Contact />
      </main>
      <Footer scrollTo={scrollTo} />
    </div>
  );
}

export default App;
